import React from 'react';

export default function Settings() {
  return (
    <div>
      <h1 data-testid="settings-title">
        Settings
      </h1>
    </div>);
}
